<script>
  import { onMount } from 'svelte';
  import categories from "./stores/categories";


  let selectedSubcategory = '';
  let subcategories = categories.flatMap(category => category.subcategories).sort();
  /**
   * 
   */
  export let category = '';
  export let setCategory;
  
  
//   function updateSubcategories(categoryName) {
//     const category = categories.find(c => c.name === categoryName);
//     subcategories = category ? category.subcategories : [];
//     selectedSubcategory = subcategories.length > 0 ? subcategories[0] : '';
//   }

  // Initialize subcategories and selectedSubcategory on component mount
  onMount(() => {
    if (category) {
    console.log(category);
      selectedSubcategory = category;
    }
  });
</script>

<select bind:value={selectedSubcategory} on:change="{() => setCategory(selectedSubcategory)}" class="mt-2 p-2 border-2 border-gray-300 rounded-lg w-full">
    {#each subcategories as subcategory}
      <option value={subcategory}>{subcategory}</option>
    {/each}
</select>
